import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from 'react-i18next';

/**
 * RTL-aware back icon. Use this instead of ArrowBackIcon directly.
 */
export function BackIcon() {
  const isRtl = document.body.dir === 'rtl';
  return isRtl ? <ArrowForwardIcon /> : <ArrowBackIcon />;
}

export function isAppMode() {
  return sessionStorage.getItem('appMode') === 'true';
}

export default function AppHeader() {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';

  return (
    <AppBar position="sticky">
      <Toolbar variant="dense" sx={{ minHeight: 48 }}>
        <IconButton edge="start" color="inherit" onClick={() => window.history.back()} sx={{ mr: 1 }}>
          {isRtl ? <ArrowForwardIcon /> : <ArrowBackIcon />}
        </IconButton>
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>
          ARIA
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
